import { createRouter } from '@tanstack/react-router';

import { rootRoute } from './routes/__root';
import { indexRoute } from './routes/index';
import { analyseRoute } from './routes/analyse';
import { assetsRoute } from './routes/assets';
import { assistantRoute } from './routes/assistant';
import { settingsRoute } from './routes/settings';
import { sitlRoute } from './routes/sitl';

const routeTree = rootRoute.addChildren([
  indexRoute,
  analyseRoute,
  assetsRoute,
  assistantRoute,
  sitlRoute,
  settingsRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
